import React, { useState, useCallback, useMemo, useEffect } from "react";

import { kebabCase, lowerCase } from "lodash";
import { Button, FormGroup, SimpleAlert, LoadingSpinner, Label, Input, Select, Row, Col } from "twyne-new.ui"

export default function Form({ data, version, onSubmit, onCancel }) {
  const [from, setFrom] = useState(null)
  const [description, setDescription] = useState("")
  const [slug, setSlug] = useState("")

  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [slugTouch, setSlugTouch] = useState(false)

  const fromOption = useMemo(() => [
    { label: "Default Version", value: "default" },
    { label: "Selected Version", value: "selected" },
  ].filter(({ value }) => value !== "selected" || version), [version])

  useEffect(() => {
    if (!from) {
      setFrom(version ? "selected" : "default")
    }
  }, [version, from])

  const handleSubmit = async () => {
    setLoading(true)
    try {
      if (!description || !slug) {
        return setError(true)
      }

      await onSubmit({ description, slug, data })
    } catch (e) {
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  const parseSlug = useCallback(value => {
    value = `${value}`
      .replace(/[^a-zA-Z0-9\-_.~ ]/g, '')
    return kebabCase(value)
  }, [])

  const handleFrom = useCallback(option => {
    const { value } = option
    setFrom(value)
  }, [])

  const handleDescription = useCallback(event => {
    const { value } = event.target
    setDescription(value)
    if (!slugTouch) {
      setSlug(parseSlug(value))
    }
  }, [slugTouch, parseSlug])

  const handleSlug = useCallback(event => {
    const { value } = event.target
    setSlugTouch(true)
    setSlug(value)
  }, [])

  return <Row>
    <Col size="12">
      <FormGroup>
        <Label>From</Label>
        <Select name="from" value={from} options={fromOption} onChange={handleFrom} disabled />
      </FormGroup>
    </Col>
    <Col size="12">
      <FormGroup>
        <Label>Description</Label>
        <Input name="description" value={description} onChange={handleDescription} />
      </FormGroup>
    </Col>
    <Col size="12">
      <FormGroup>
        <Label>Slug</Label>
        <Input name="slug" value={slug} onChange={handleSlug} />
      </FormGroup>
    </Col>
    <Col size="12">
      <Alert error={error} />
    </Col>
    <Col size="12">
      <div className="flex gap-2">
        <Button onClick={handleSubmit} className="flex items-center" color="accent" disabled={loading}>
          {loading ? <LoadingSpinner width={18} height={18} /> : "Save"}
        </Button>
        <Button color="neutral" variant="ghost" onClick={onCancel}>Cancel</Button>
      </div>
    </Col>
  </Row>
}

function Alert({ error }) {
  if (!error) {
    return null;
  }

  return <SimpleAlert variant="danger">
    We can not create a new version
  </SimpleAlert>
}
